// =========== plugin import ============= //
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// =========== component import ============ //
import { PageTitle } from '../../../../_template/layout/core/PageData';

const DevProfile = () => {

    const pageTitle = [
        {
            title: 'Agents',
            path: '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    // -------- define all state here ------- //
    const [isUpdate, setIsUpdate] = useState(false);

  

    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>Profile</PageTitle>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="card mb-5 mb-xl-10">
                        <div className="card-header">
                            <div className="card-title m-0">
                                <h3 className="fw-bold m-0 fs-2x">
                                    {
                                        !isUpdate &&
                                        `Profile Details`
                                    }
                                    {
                                        isUpdate &&
                                        `Update Profile`
                                    }
                                </h3>
                            </div>
                            {
                                !isUpdate &&
                                <div 
                                    className="btn btn-sm btn-primary align-self-center" 
                                    onClick={() => setIsUpdate(true)}>
                                    Edit Profile
                                </div>
                            }
                        </div>
                        <div className="card-body p-9">
                            {
                                !isUpdate &&
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">Full Name</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    Abhijit Maity
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">
                                                System User Email
                                            </label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">
                                                    abhijit@softamassindia.com
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">
                                                Assign Agent
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <span className="badge badge-light-primary me-2">
                                                    agent_1
                                                </span>
                                                <span className="badge badge-light-primary me-2">agent_2</span>
                                                <span className="badge badge-light-primary me-2">agent_3</span>
                                            </div>
                                        </div>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">
                                                Manage Permission
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <span className="badge badge-light-dark me-2">
                                                    Allow Edit
                                                </span>
                                                <span className="badge badge-light-dark me-2">Allow Delete</span>
                                            </div>
                                        </div>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">
                                                Username
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <span className="fw-bold fs-6 text-gray-800 me-2">
                                                    abhi_dev
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-7">
                                            <label className="col-lg-4 fw-semibold text-muted">
                                                Password
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <span className="fw-bold fs-6 text-gray-800 me-2">*********</span>
                                                <FontAwesomeIcon 
                                                    icon={faEye} 
                                                    className='fs-6 cursor-pointer text-gray-600 mb-2'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                isUpdate && 
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">
                                                Full Name
                                            </label>
                                            <div class="col-lg-8">
                                                <div class="row">
                                                    <div class="col-lg-6 fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                                        <input type="text" name="fname" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="First name" />
                                                    </div>
                                                    <div class="col-lg-6 fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                                        <input type="text" name="lname" class="form-control form-control-lg form-control-solid" placeholder="Last name" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">
                                                Email
                                            </label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="text" name="company" class="form-control form-control-lg form-control-solid" placeholder="Enter your email" />
                                            </div>
                                        </div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">
                                                Password
                                            </label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="text" name="company" class="form-control form-control-lg form-control-solid" placeholder="Enter your password" />
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-12 text-end">
                                                <div 
                                                    class="btn btn-danger me-4" 
                                                    onClick={() => setIsUpdate(false)}
                                                >
                                                    Cancel
                                                </div>
                                                <div class="btn btn-primary false">Save</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DevProfile